import { Panel } from "primereact/panel";

const PrimePanel = ({ toggleable, className, header, headerTemplate, children, style, onToggle, collapsed }) => {
  return (
    <Panel
      toggleable={toggleable}
      // 讓上層可控制面板初始收合狀態（例如預設收合）
      collapsed={collapsed}
      className={className}
      style={style}
      header={header}
      headerTemplate={headerTemplate}
      collapseIcon="pi pi-chevron-down"
      expandIcon="pi pi-chevron-left"
    >
      {children}
    </Panel>
  );
};

export default PrimePanel;
